import { defineStore } from 'pinia'
import { api } from '@/plugins/api'

// ADAS Map Mobile pricing (Launchpad API appPricing/*). Billing Admin (role 28) and Super
// Admin only on the API side. Prices are append-only: a save adds a value and deactivates
// the one it replaces; nothing is edited or deleted.
export const appPricingStore = defineStore('appPricing', {
  state: () => ({
    settings: {
      current: [],
      history: []
    },
    loading: {
      settings: false,
      saving: false
    }
  }),
  actions: {
    async getSettings() {
      this.loading.settings = true
      try {
        const data = await api.get('appPricing/settings')
        this.settings = data || { current: [], history: [] }
      } finally {
        this.loading.settings = false
      }
    },
    async saveSetting(settingCode, value, note) {
      this.loading.saving = true
      try {
        return await api.post('appPricing/save', { settingCode, value, note })
      } finally {
        this.loading.saving = false
      }
    }
  }
})
